import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth?: boolean;
}

export const ProtectedRoute = ({ children, requireAuth = true }: ProtectedRouteProps) => {
  const { user, loading } = useAuth();

  if (loading) {
    return null; // or a loading spinner
  }

  if (requireAuth) {
    // Redirect to login if not authenticated
    return user ? <>{children}</> : <Navigate to="/" replace />;
  } else {
    // Redirect to dashboard if already authenticated
    return !user ? <>{children}</> : <Navigate to="/dashboard" replace />;
  }
};
